"use client";

import { useState } from "react";
import Button from "./Button";


export default function Footer() {
  return (
    <footer className="border flex flex-col w-full">
      <div className="container mx-auto">
        <div className="border-b-[1px] py-4 pe-4 ps-4 md:pe-4 md:ps-4 flex flex-col items-center">
          <p className="mb-4 text-md sm:text-lg md:text-xl text-center text-[#4f39f6] font-bold">
            Get started
          </p>
          <h1 className="mb-4 text-center text-black font-semibold">
            Boost your productivity. <br /> Start using our app today.
          </h1>
          <p className="mb-4 text-md sm:text-lg md:text-xl text-center text-[#4a5565]">
            Incididunt sint fugiat pariatur cupidatat consectetur sit cillum
            anim id <br /> veniam aliqua proident excepteur commodo do ea.
          </p>
          <Button variant="primary">Get Started</Button>
        </div>
        <div className="flex flex-col md:flex-row py-4 px-4 items-center md:items-start text-center md:text-left gap-8">
          <div className="w-full md:w-1/3 flex flex-col items-center md:items-start mb-6 md:mb-0">
            <p>LOGO</p>
            <p>MOTTO</p>
            <p>Social İcons</p>
          </div>

          <div
            id="about-company"
            className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8"
          >
            {/* Solutions */}
            <div className="flex flex-col gap-4 items-center sm:items-start text-center sm:text-left">
              <h4>Solutions</h4>
              <a href="">Marketing</a>
              <a href="">Analytics</a>
              <a href="">Automation</a>
              <a href="">Commerce</a>
              <a href="">Finance</a>
            </div>

            {/* Support */}
            <div className="flex flex-col gap-4 items-center sm:items-start text-center sm:text-left">
              <h4>Support</h4>
              <a href="">Guides</a>
              <a href="">Documentation</a>
              <a href="">Contact</a>
            </div>

            {/* Company */}
            <div className="flex flex-col gap-4 items-center sm:items-start text-center sm:text-left">
              <h4>Company</h4>
              <a href="">About</a>
              <a href="">Blog</a>
              <a href="">Jobs</a>
              <a href="">Press</a>
            </div>

            {/* Legal */}
            <div className="flex flex-col gap-4 items-center sm:items-start text-center sm:text-left">
              <h4>Legal</h4>
              <a href="">Terms of Service</a>
              <a href="">Privacy Policy</a>
              <a href="">Licence</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
